import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { makeCRMApi } from '../CrmApi';
import { INotification, INotificationSearchRequest, INotificationSearchResponse } from '../types/NotificationTypes';
import { AxiosError, AxiosResponse } from 'axios';

export const useCrmNotifications = (notificationSearchRequest: INotificationSearchRequest, shouldMakeRequest: boolean = true) => {
  const crmApi = makeCRMApi();
  
  const crmNotificationsResponse = useInfiniteQuery<AxiosResponse<INotificationSearchResponse>, AxiosError>({
    queryKey: ['crm-notifications', notificationSearchRequest],
    queryFn: ({ pageParam = 0 }) => {
      const offset = typeof pageParam === 'number' ? pageParam : 0;
      const request: INotificationSearchRequest = {
        ...notificationSearchRequest,
        pagination: { ...notificationSearchRequest.pagination, offset },
      };
      return crmApi.searchNotifications(request);
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.data.list.length < notificationSearchRequest.pagination.limit) {
        return undefined;
      }
      const itemsLength = allPages.flatMap(item => item.data.list).length;
      return itemsLength;
    },
    enabled: shouldMakeRequest,
    refetchOnReconnect: false,
    staleTime: 0,
    gcTime: 0,
  });
  const notifications: INotification[] = crmNotificationsResponse.data?.pages?.flatMap(item => item.data.list) ?? [];
  const notificationsCount = crmNotificationsResponse.data?.pages[0].data.count ?? 0;

  return {
    notifications,
    crmNotificationsResponse,
    notificationsCount,
  };
}
